export default __webpack_public_path__ + "static/media/img-06-mini.7e604364.png";